import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var RoyalIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M5.052 3.55a1.1 1.1 0 101.905 1.1 1.1 1.1 0 00-1.905-1.1zM9.052 3.55a1.1 1.1 0 101.905 1.1 1.1 1.1 0 00-1.905-1.1zM13.052 3.55a1.1 1.1 0 101.905 1.1 1.1 1.1 0 00-1.905-1.1zM17.455 5.053a1.1 1.1 0 111.1-1.905 1.1 1.1 0 01-1.1 1.905zM1.55 21.053a1.1 1.1 0 111.1-1.905 1.1 1.1 0 01-1.1 1.905zM9.148 19.55a1.1 1.1 0 101.905 1.1 1.1 1.1 0 00-1.905-1.1zM13.148 19.55a1.1 1.1 0 101.905 1.1 1.1 1.1 0 00-1.905-1.1zM17.55 21.053a1.1 1.1 0 111.1-1.905 1.1 1.1 0 01-1.1 1.905zM21.148 19.55a1.1 1.1 0 101.905 1.1 1.1 1.1 0 00-1.905-1.1zM5.148 19.55a1.1 1.1 0 101.905 1.1 1.1 1.1 0 00-1.905-1.1zM1.148 15.55a1.1 1.1 0 101.905 1.1 1.1 1.1 0 00-1.905-1.1zM9.55 17.053a1.1 1.1 0 111.1-1.905 1.1 1.1 0 01-1.1 1.905zM13.55 17.053a1.1 1.1 0 111.1-1.905 1.1 1.1 0 01-1.1 1.905zM17.148 15.55a1.1 1.1 0 101.905 1.1 1.1 1.1 0 00-1.905-1.1zM21.55 17.053a1.1 1.1 0 111.1-1.905 1.1 1.1 0 01-1.1 1.905zM5.55 17.053a1.1 1.1 0 111.1-1.905 1.1 1.1 0 01-1.1 1.905zM2 8a1 1 0 011-1h18a1 1 0 110 2H3a1 1 0 01-1-1zM1.148 11.55a1.1 1.1 0 101.905 1.1 1.1 1.1 0 00-1.905-1.1zM9.55 13.053a1.1 1.1 0 111.1-1.905 1.1 1.1 0 01-1.1 1.905zM13.55 13.053a1.1 1.1 0 111.1-1.905 1.1 1.1 0 01-1.1 1.905zM17.148 11.55a1.1 1.1 0 101.905 1.1 1.1 1.1 0 00-1.905-1.1zM21.55 13.053a1.1 1.1 0 111.1-1.905 1.1 1.1 0 01-1.1 1.905zM5.55 13.053a1.1 1.1 0 111.1-1.905 1.1 1.1 0 01-1.1 1.905z"
                    })
                })
            })
        ]
    });
};
RoyalIcon.isCarinaIcon = true;
export default RoyalIcon;
